module.exports = __webpack_public_path__ + "static/media/styledmenu-arrow-down.4248c4bf.svg";